import React, { useEffect, useState } from "react";
import DocumentPopup from "./DocumentPopup";


import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';

import sketchMr from '../../resource/Art/benneyL2026.PNG';
import art1 from '../../resource/Art/art1.jpg';
import art2 from '../../resource/Art/art2.jpg';
import art3 from '../../resource/Art/art3.jpg';
import art4 from '../../resource/Art/art4.jpg';
import art5 from '../../resource/Art/art5.jpg';
import art6 from '../../resource/Art/art6.jpeg';
import art7 from '../../resource/Art/art7.jpeg';
import art8 from '../../resource/Art/art8.jpg';

// Functional Component
const Hobbies = () => {

  const [isManifestoOff, setisManifestoOff] = useState(false);
  const [artData, setArtData] = useState([
    {
      img: art5,
      name: 'art2',
      author: "benny",
      cols: 2
    },
    {
      img: art1,
      name:  'art1',
      author: "benny",
      cols: 1
    },
    {
      img: art3,
      name: 'art3',
      author: "benny",
      cols: 1
    },
    {
      img: art6,
      name: 'art6',
      author: "benny",
      cols: 1
    },
    {
      img: art7,
      name: 'art7',
      author: "benny",
      cols: 1
    },
    {
      img: art2,
      name: 'art4',
      author: "benny",
      cols: 1
    },
    {
      img: art4,
      name: 'art5',
      author: "benny",
      cols: 1
    },
    {
      img: art8,
      name: 'art8',
      author: "benny",
      cols: 2
    },
  ])

  useEffect(() => {
    if (window.location.pathname === "/manifesto") {
      setisManifestoOff(true);
    }
  }, []);

  return (
    <div className="hobbiesPage">
      {
        isManifestoOff &&
        <div>
          <DocumentPopup
            isOpen={isManifestoOff}
            onClose={() => {
              setisManifestoOff(false)
              window.history.pushState({}, "", "/");
            }}
          />
        </div>
      }
      <div>
        <div className="hobbiesContent">
          <div className="sketchContainer">
            <img src={sketchMr} className="sketchMr" />
            <div className="sketchDesc">
              {/* <p>I'm also a <b>writer</b> and a <b>sketch artist</b>! From social commenaty such as <b><span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => {setisManifestoOff(true);window.history.pushState({}, "", "/manifesto");}}>The Anti-Patrirach Manifesto</span></b>, to fantasy novels and <b>character design</b>. See a selection of sketches below!</p> */}
              <p>I'm also a <b>writer</b> and a <b>sketch artist</b>! From social commenaty such as The Anti-Patrirach Manifesto, to fantasy novels and <b>character design</b>. See a selection of sketches below!</p>
            </div>
          </div>
        </div>
        <GridList style={{ width: "100%" }} cellHeight={500} cols={2}>
          {artData.map((tile, i) => (
            <GridListTile key={i} cols={tile.cols || 1}>
              <img src={tile.img} alt={tile.title} />
            </GridListTile>
          ))}
        </GridList>
      </div>
    </div>
  );
};

export default Hobbies;